<div class="rs-flex-row rs-flex-middle">
  <div class="rs-flex-columns">
    <div
      class="panel rs-wd-s18 rs-wd-s21 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>
  <div class="rs-flex-columns rs-flex-grow">
    <div
      class="panel rs-wd-s5 rs-wd-m6 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>
</div>
<div class="panel rs-bg-grey1 clearfix">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>

  <div
    class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
  ></div>
  <div
    class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
  ></div>
  <div
    class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading hide-for-medium-up"
  ></div>
  <div
    class="panel rs-maxw rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
  ></div>

  <div class="rs-flex-row">
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="panel rs-bg-grey1 clearfix">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>

  <div class="rs-flex-row">
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-columns small-12 medium-6 end">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="panel rs-bg-grey1 clearfix">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>

  <div class="rs-flex-row">
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-columns small-12 medium-6 end">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="panel rs-bg-grey1 clearfix">
  <div class="small-only-text-center">
    <div
      class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
    ></div>
  </div>

  <div class="rs-flex-row">
    <div class="rs-flex-columns small-12 medium-6">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-flex-columns small-12 medium-6 end">
      <div class="rs-panel-flex">
        <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
          <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
            <div class="rs-flex-column rs-maxh">
              <div class="rs-flex-row rs-flex-collapse rs-maxh">
                <div class="small-4 rs-flex-columns">
                  <div
                    class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                  ></div>
                </div>
                <div class="small-8 rs-flex-columns">
                  <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                    <div class="rs-txt-c1 rs-padding-bottom1">
                      <div
                        class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                      <div
                        class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
              <div
                class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="rs-flex-row">
  <div class="rs-flex-columns small-12 medium-6">
    <div class="panel rs-bg-grey1 clearfix">
      <div class="small-only-text-center">
        <div
          class="panel rs-inline-block rs-wd-s16 rs-h-s2 rs-h-m3 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
        ></div>
      </div>

      <div>
        <div class="rs-panel-flex">
          <div class="rs-panel-flex-cell rs-no-padding-left rs-no-padding-top rs-bg-grey2">
            <div class="rs-flex-row rs-flex-middle rs-flex-collapse rs-maxh">
              <div class="rs-flex-column rs-maxh">
                <div class="rs-flex-row rs-flex-collapse rs-maxh">
                  <div class="small-4 rs-flex-columns">
                    <div
                      class="rs-panel-flex-cell-big rs-maxh rs-radius rs-no-radius-right rs-bg-grey4 rs-anim-loading"
                    ></div>
                  </div>
                  <div class="small-8 rs-flex-columns">
                    <div class="rs-panel-flex-cell rs-flex rs-flex-middle rs-maxh">
                      <div class="rs-txt-c1 rs-padding-bottom1">
                        <div
                          class="panel rs-wd-s9 rs-wd-m14 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                        <div
                          class="panel rs-wd-s11 rs-wd-m27 rs-h-s2 rs-no-padding rs-margin-bottom1 rs-bg-grey4 rs-anim-loading"
                        ></div>
                        <div
                          class="panel rs-wd-s11 rs-wd-m22 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                        <div
                          class="panel rs-wd-s11 rs-wd-m17 rs-h-s2 rs-no-padding rs-margin-bottom2 rs-bg-grey4 rs-anim-loading"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rs-flex-column rs-flex-shrink rs-flex-middle">
                <div
                  class="panel rs-inline-block rs-wd-s3 rs-h-s3 rs-no-padding rs-radius-circle rs-no-margin rs-bg-grey4 rs-anim-loading"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
